export default __webpack_public_path__ + "static/media/thomas_on.245d3550.png";